const icon = require('vue-svgicon');
icon.register({
    'logo': {
        width: 44,
        height: 14,
        viewBox: '0 0 44 14',
        data: `<path pid="0" _fill="url(#pattern0)" d="M0 0h44v14H0z"/><defs><pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1"><use xlink:href="#image0" transform="scale(.00575 .01786)"/></pattern><image id="image0" width="174" height="56" xlink:href="/static/logo.png"/></defs>`,
    },
});
